import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { useFarbwelt, useIsDesktop } from "@/hooks";
export const SectionsWrapper = ({ children }) => {
    const { bgColor, logo, isFarbweltActive } = useFarbwelt();
    const hasBanner = isFarbweltActive && (bgColor || logo);
    const isDesktop = useIsDesktop();
    return (_jsx(Box, { width: "100%", display: "flex", flexDirection: "column", backgroundColor: "color.background.constant.white", borderRadius: "radius.16", marginTop: {
            "breakpoint.base": "-spacing.16",
            "breakpoint.lg": "unset",
        }, paddingTop: {
            "breakpoint.base": "spacing.16",
            "breakpoint.lg": "unset",
        }, paddingRight: {
            "breakpoint.base": "spacing.none",
            "breakpoint.xxxl": "spacing.128",
        }, position: "relative", unsafe_style: {
            boxShadow: hasBanner && !isDesktop
                ? "0px -20px 24px -24px rgba(0, 0, 0, 0.16)"
                : undefined,
        }, children: children }));
};
